<template>
	<div class="StyleGuide">
		<div class="component">
			<h1>This is a heading.</h1>
			<p>Followed by a paragraph.</p>
		</div>
		<div class="component">
			<p>This is a paragraph.</p>
			<p>Followed by another paragraph.</p>
		</div>

		<div class="component">
			<p>Button (clicked {{buttonClicks}} times):</p>
			<Button @click="buttonClicks++">This is button</Button>
		</div>

		<div class="component">
			<p>This is an input:</p>
			<Input/>
		</div>

		<div class="component">
			<p>This is an input:</p>
			<Input/>
		</div>

		<div class="component">
			<p>This is a labeled input:</p>
			<Input label="Username"/>
		</div>

	</div>
</template>

<script>
import Button from '../components/Button'

export default {
	name: 'StyleGuide',
	data: function() {
		return {
			buttonClicks: 0
		}
	},
	components: {
		Button
	}
}
</script>

<style lang="stylus" scoped>
.StyleGuide {
	min-height: 600px
	border: 1px dashed #888
}

.component:not(:first-child) {
	border-top: 1px dotted #888
}

.component:last-child {
	border-bottom: 1px dotted #888
}
</style>
